import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store=new Vuex.Store({
    state:{
        s:-1,
        solution:0,
        PageId:false,
    },
    mutations:{
        PageIds(state,n){
            state.PageId=n
        },
        Navigation(state,n){
            state.s=n                                                                                                             
        },
        solutions(state,n){
            state.solution=n      
        }

    }

})


export default store
